import React from "react"
import { Box, Button, Divider, Grid, Tooltip, Typography } from "@mui/material"
import * as Style from "./style"
import moment from "moment"
import { FaChevronLeft } from "react-icons/fa6"
import { useNavigate, useParams } from "react-router-dom"
import { useGetProviderListQuery } from "../../features/OverViewAuth/overViewApi"
import { CalculateTimeDifference } from "../Notification/timeNotification"
import RatingStars from "../common/rating"
import CenteredSpinner from "../common/CenteredSpinner"
import dummy from "../../images/dummy-icon.png"
import { BsInfoCircleFill } from "react-icons/bs"
const ProviderProfile = () => {
  const { id } = useParams()
  const navigate = useNavigate()

  const {
    data: profileView,
    isFetching,
    isLoading,
  } = useGetProviderListQuery({ id })

  const servicesArray = profileView?.data?.providerData?.services?.map(
    (item: any) => item?.name,
  )

  const tagStyle = {
    border: "1px solid #F475A4",
    padding: "4px 8px",
    borderRadius: "8px",
    marginRight: "8px",
    marginBottom: "8px",
    display: "inline-block",
    backgroundColor: "#F475A4",
    color: " #fff",
  }

  return (
    <>
      {" "}
      {isFetching || isLoading ? (
        <CenteredSpinner />
      ) : (
        <Style.Overview>
          <Box className="position-relative">
            <Button
              className="back-btn mb-0 profile-back"
              onClick={() => navigate(-1)}
            >
              <FaChevronLeft />
            </Button>
            <Grid container className="justify-content-center">
              <Grid xs={12} lg={8} className="pe-md-4">
                <Grid container>
                  <Grid xs={12}>
                    <Box className="profile-page-header">
                      <Typography className="profile-heading">
                        Profile Page
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
                <Box className="review-card p-4 mt-0 d-flex flex-column align-items-center  single-review-card">
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={8} sx={{ order: { xs: 2, sm: 0 } }}>
                      <Grid container className="mb-4">
                        <Grid md={5}>
                          <Typography variant="body1" className="pe-2">
                            <strong> Email </strong>
                          </Typography>
                        </Grid>
                        <Grid md={7} className="d-flex">
                          <Typography
                            variant="body1"
                            className="text-truncate"
                            style={{ wordWrap: "break-word", width: "150px" }}
                          >
                            {profileView?.data?.providerData?.email || "-----"}
                          </Typography>
                          <Tooltip
                          title={profileView?.data?.providerData?.email || "-----"}
                          arrow
                        >
                          <Button
                            style={{ minWidth: "10px" }}
                            className="m-0 p-0"
                          >
                           <BsInfoCircleFill color="#F475A4" />
                          </Button>
                        </Tooltip>
                        </Grid>
                      </Grid>
                      <Grid container className="mb-4">
                        <Grid md={5}>
                          <Typography variant="body1" className="pe-2">
                            <strong> Phone Number </strong>
                          </Typography>
                        </Grid>
                        <Grid md={7}>
                          <Typography variant="body1">
                            {profileView?.data?.providerData?.contactNo}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container className="mb-4">
                        <Grid md={5}>
                          <Typography variant="body1" className="pe-2">
                            <strong> Rating </strong>
                          </Typography>
                        </Grid>
                        <Grid md={7}>
                          <Typography
                            variant="body1"
                            className="  gap-2 justify-content-center align-items-center mb-1"
                            style={{ color: "gold" }}
                          >
                            <RatingStars
                              rating={
                                profileView?.data?.providerData?.rating
                                  ?.$numberDecimal || "--"
                              }
                            />
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container className="mb-4">
                        <Grid md={5}>
                          <Typography variant="body1" className="pe-2">
                            <strong> Date Of Birth </strong>{" "}
                          </Typography>
                        </Grid>
                        <Grid md={7}>
                          {profileView?.data?.providerData?.dob ? (
                            <Typography variant="body1" className="pe-2">
                              {moment(
                                profileView?.data?.providerData?.dob,
                              ).format("DD-MM-YYYY")}
                            </Typography>
                          ) : (
                            "--"
                          )}
                        </Grid>
                      </Grid>
                      <Grid container className="mb-4">
                        <Grid md={5}>
                          <Typography variant="body1" className="pe-2">
                            <strong> Gender </strong>{" "}
                          </Typography>
                        </Grid>
                        <Grid md={7}>
                          <Typography variant="body1">
                            {profileView?.data?.providerData?.gender || "--"}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container className="mb-4">
                        <Grid md={5}>
                          <Typography variant="body1" className="pe-2">
                            <strong> Language </strong>
                          </Typography>
                        </Grid>
                        <Grid md={7}>
                          <Typography variant="body1" className="pe-2">
                            {profileView?.data?.providerData?.language?.join(
                              " ",
                            )}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container className="mb-4">
                        <Grid md={5}>
                          <Typography variant="body1" className="pe-2">
                            <strong> Origin Country </strong>
                          </Typography>
                        </Grid>
                        <Grid md={7}>
                          <Typography variant="body1">
                            {profileView?.data?.providerData?.region}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={4} sx={{ order: { xs: 1, sm: 0 } }}>
                      {" "}
                      <Box className="mb-3">
                        <img
                          src={profileView?.data?.providerData?.profilePic}
                          className="profile-img "
                          style={{
                            width: "100px",
                            height: "100px",
                            borderRadius: "12px",
                          }}
                        />
                      </Box>
                      <Box className="mb-4">
                        <Typography className="service-provider-name">
                          {profileView?.data?.providerData?.name}
                        </Typography>
                        <Typography className="service-provider-bio">
                          {profileView?.data?.providerData?.description}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid container className="mb-4">
                    <Grid md={5}>
                      <Typography variant="body1" className="pe-2 mb-2">
                        <strong> Services Offered </strong>
                      </Typography>
                    </Grid>
                    <Grid md={12}>
                      <Typography variant="body1">
                        {servicesArray.map((service: string, index: number) => (
                          <span key={index} style={tagStyle}>
                            {service}{" "}
                          </span>
                        ))}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container className="overflow-x-auto">
                    <Grid md={12}>
                      <Divider className="dark-divider my-4" />
                      <Typography
                        variant="body1"
                        align="left"
                        className="text-dark mb-3"
                      >
                        <strong>Reviews</strong>
                      </Typography>

                      <Grid container className="mb-4">
                        {profileView?.data?.providersReview?.length > 0 ? (
                          profileView.data.providersReview.map((item: any, index: number) => (
                            <Grid item xs={12} key={index}>
                              <Box className="inner-review-card my-3 me-2">
                                <Box className="d-flex justify-content-between align-items-center mb-1 gap-3">
                                  <Box className="d-flex gap-2 align-items-center">
                                    <img
                                      src={item?.seekerData?.profilePic || dummy}
                                      className="inner-profile-img"
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "12px",
                                      }}
                                    />
                                    <Typography variant="body1">
                                      {item?.seekerData?.name}
                                    </Typography>
                                  </Box>

                                  <Box>
                                    <Typography
                                      variant="body1"
                                      className="d-flex gap-2 align-items-center"
                                      style={{ color: "gold" }}
                                    >
                                      <RatingStars rating={item?.rating} />
                                    </Typography>
                                  </Box>

                                  <Box>
                                    <Typography variant="body1">
                                      <CalculateTimeDifference createdAt={item?.createdAt} />
                                    </Typography>
                                  </Box>
                                </Box>

                                <Box className="d-flex gap-1">
                                  <Typography
                                    sx={{ fontWeight: 600, color: "pink.main", paddingRight: "1px" }}
                                  >
                                    Review:
                                  </Typography>
                                  <Typography variant="body1">{item?.message}</Typography>
                                </Box>
                              </Box>
                            </Grid>
                          ))
                        ) : (
                          <Grid item xs={12}>
                            <Typography
                              variant="body2"
                              align="center"
                              sx={{ color: "text.secondary", mt: 2 }}
                            >
                              No Reviews Yet
                            </Typography>
                          </Grid>
                        )}
                      </Grid>

                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Style.Overview>
      )}
    </>
  )
}
export default ProviderProfile
